<h1 mat-dialog-title>Remove flight leg?</h1>
<div mat-dialog-content>Are you sure you want to remove this leg?</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close('delete')">
    <mat-icon>delete</mat-icon> Delete
  </button>
  <button mat-raised-button (click)="dialogRef.close('cancel')">
    <mat-icon>cancel</mat-icon> Cancel
  </button>
</div>
